export const Suadi_fintech_URL = process.env.REACT_APP_NEXDUS_BASE_URL;
export const Saudi_App_Base_URL = process.env.REACT_APP_BASE_URL;
